"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeatmapHeader = exports.HEATMAP_CELL_WIDTH = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var mobx_react_1 = require("mobx-react");
var react_tippy_1 = require("react-tippy");
var Tooltip_1 = require("../../ui/Tooltip");
//#region INTERNAL FUNCTIONS
var isChildTitleOddClass = function (index) {
    var className = "";
    if ((index + 1) % 2 !== 0)
        className = "heatmap__header-child-title--odd";
    return className;
};
var firstChildTitleClass = function (index) {
    var className = "";
    if (index === 0)
        className = "heatmap__header-child-title--first";
    return className;
};
var childTitleClassName = function (index) {
    return "heatmap__header-child-title\n    ".concat(isChildTitleOddClass(index), "\n    ").concat(firstChildTitleClass(index));
};
var ChildTooltip = function (_a) {
    var element = _a.element;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "heatmap__header--t" }, { children: (0, jsx_runtime_1.jsx)(react_tippy_1.Tooltip, __assign({ theme: "light", position: Tooltip_1.TooltipPositions.LEFT, followCursor: true, html: (0, jsx_runtime_1.jsx)("small", __assign({ className: "d-block" }, { children: element.label })) }, { children: (0, jsx_runtime_1.jsx)("p", __assign({ className: "mb-0 text-truncate" }, { children: element.label })) })) })));
};
//#endregion
exports.HEATMAP_CELL_WIDTH = 100;
var HeatmapHeader = (0, mobx_react_1.observer)(function (_a) {
    var model = _a.model;
    var headers = model.xAxisHeaders;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "heatmap__header" }, { children: headers.map(function (k, ii) {
            return ((0, jsx_runtime_1.jsx)("div", __assign({ className: childTitleClassName(ii) }, { children: (0, jsx_runtime_1.jsx)(ChildTooltip, { element: k }) }), "k" + ii));
        }) })));
});
exports.HeatmapHeader = HeatmapHeader;
